module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTW05-75Bold.08ec9cae.woff2";